export const tramites_item = [
    {
        "tramites_item_nombre" : "Cursos impartidos en Unidades de Educación Artística y Centros Culturales Regionales",
        "tramites_item_descripcion" : "Cursos impartidos en Unidades de Educación Artística y Centros Culturales Regionales",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/12007"
    },
     {
        "tramites_item_nombre" : "Programa Escolarizado de Educación Artística Inicial del Centro de las Artes de Hidalgo",
        "tramites_item_descripcion" : "Programa Escolarizado de Educación Artística Inicial del Centro de las Artes de Hidalgo",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/11887"
    },
     
    {
        "tramites_item_nombre" : "Cursos escolarizados y talleres artísticos impartidos en Unidades de Educación Artística y Centros Culturales Regionales",
        "tramites_item_descripcion" : "Cursos escolarizados y talleres artísticos impartidos en Unidades de Educación Artística y Centros Culturales Regionales",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/566"
    },
    {
        "tramites_item_nombre" : "Becas para alumnado del Programa Estatal de Educación Artística del CECULTAH",
        "tramites_item_descripcion" : "Brindar apoyo con una beca del 25%, 50% o 75% para que los alumnos continúen con sus estudios en el Centro de las Artes de Hidalgo en los ciclos de Educación Artística Inicial (Sistema escolarizado) y en los talleres libres cuya condición administrativa lo permita",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/7059"
    },
    {
        "tramites_item_nombre" : "Talleres Artisticos especializados del Centro de las Artes de Hidalgo",
        "tramites_item_descripcion" : "Talleres de formación especializada en las disciplinas de música, danza, teatro, artes visuales y literatura.",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/585"
    },
    {
        "tramites_item_nombre" : "Talleres artísticos  impartidos en el Centro de las Artes de Hidalgo",
        "tramites_item_descripcion" : "Talleres de formación inicial para desarrollar habilidades en las disciplinas de música, danza, teatro, artes visuales y literatura",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/583"
    },
     {
        "tramites_item_nombre" : "Cursos de verano en la Unidades de Educación Artística",
        "tramites_item_descripcion" : "Cursos de verano en la Unidades de Educación Artística",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/12005"
    },
     {
        "tramites_item_nombre" : "Expedición de credencial en Centro de las Artes y Centros Culturales Regionales",
        "tramites_item_descripcion" : "Expedición de credencial en Centro de las Artes y Centros Culturales Regionales",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/12006"
    },
     {
        "tramites_item_nombre" : "Encuesta de Satisfacción de Trámites del CECULTAH",
        "tramites_item_url" : "https://docs.google.com/forms/d/e/1FAIpQLSeIvIpq3z97rSjhFbJxTKqAMf42x0OGsUSbvN5H4xH-nx-xPg/viewform"
    },

]